import React from 'react'
import * as UI from 'ui'
import { Model, useValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'

export default function MyMessageInner () {
  const id = useValue('id')

  return (
    <Model resourceName='messages.messages' operationName='mine_read' id={id}>
      <UI.Text tag='div' size='sm' className='pb-6'>
        <Displays.Html name='content_long' />
      </UI.Text>
    </Model>
  )
}
